// noinspection JSUnusedGlobalSymbols

'use client';

import _ from 'lodash';

import type {IUser, IUserSignupResponse, IUserSession, IAsset, IAssetFeed} from "@isudio/data";
import {UserStatus} from "@isudio/data";
import {$store, $data, $e} from "../global";
import {$socket} from "../global";

export async function setupListeners() {
  if ($store.User) {
    if ($store.User.session$) {
      $store.User.session$.subscribe((session: IUserSession) => {
        $store.User.session = session;
        $store.User.signedIn$.next(_.isValidSession());
      });
    }

    if ($store.User.userPhoto$) {
      $store.User.userPhoto$.subscribe((photo: any) => {
        $store.User.userPhoto = photo;
      });
    }

    if ($store.User.user$) {
      $store.User.user$.subscribe((user: IUserSignupResponse | IUser) => {
        $store.User.user = user;
        if (user?.photo && !_.isEqual(user?.photo, $store.User.userPhoto)) {
          $store.User.userPhoto$.next(user.photo);
        } else {
          $store.User.userPhoto$.next(null);
        }

        $store.User.activationPending$.next(user?.status === UserStatus.activationPending);
        $store.User.signedIn$.next(_.isValidSession());
      });
    }

    if ($store.Data) {
      if ($store.Data.assets$) {
        $store.Data.assets$.subscribe((assets: IAsset[]) => {
          if (_.isNothing(assets) || assets.length === 0) return;
          $store.Data.assets = assets;
        });
      }

      if ($store.Data.assetFeeds$) {
        $store.Data.assetFeeds$.subscribe((assetFeeds: IAsset[]) => {
          if (_.isNothing(assetFeeds) || assetFeeds.length === 0) return;
          $store.Data.assetFeeds = assetFeeds;
        });
      }
    }

    $store.User.activationPending$.subscribe(_.refreshMenu);
    $store.User.signedIn$.subscribe(_.refreshMenu);

    $e.events.signedIn.event.subscribe(async (user: IUser) => {
      // await $data.setup().then(async () => {
      //   await $socket.listen();
      //   if (_.isBrowser() && _.isDebug()) {
      //     window.$data = $data;
      //     window.$socket = $socket;
      //   }
      // });

      _.loadBackgroundCache([
        user.photo.thumbnail,
        user.photo.resized["size-sm"]
      ])
    });

    $e.events.socketConnected.event.subscribe((payload: any) => {
      _.logDebug(`Socket connected. (ID #${payload})`);
    });

    $e.events.socketReconnected.event.subscribe((payload: any) => {
      _.logDebug(`Socket reconnected. (ID #${payload})`);
    });

    $e.events.socketDisconnected.event.subscribe(() => {
      _.logDebug(`Socket disconnected!`);
    });

  }
}
